import axios, { AxiosError } from "axios"
import { CLOSING_DATE_PATH, CLOSING_DATE_RETENTION_PATH, LIST_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getClosingDatesService = async () => {
  try {
    const result = await instance.get(CLOSING_DATE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getClosingDatesRetentionService = async () => {
  try {
    const result = await instance.get(CLOSING_DATE_RETENTION_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getClosingDateByMonthAndYearService = async (
  month: number,
  year: number
) => {
  try {
    const result = await instance.get(`${CLOSING_DATE_PATH}/${year}/${month}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getClosingDateRetentionByMonthAndYearService = async (
  month: number,
  year: number
) => {
  try {
    const result = await instance.get(`${CLOSING_DATE_RETENTION_PATH}/${year}/${month}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const saveClosingDateService = async (closingDate: any) => {
  try {
    const result = await instance.post(CLOSING_DATE_PATH, closingDate)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const saveClosingDateRetentionService = async (closingDate: any) => {
  try {
    const result = await instance.post(CLOSING_DATE_RETENTION_PATH, closingDate)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

